import { Moon } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgMoonStars = mkIcon(Moon);